import { GET, POST, PUT, DELETE } from './api';

export const ReadFavorites = async (profileId: number | string, token: string) => {
  return await GET(`/favorites?profile=${profileId}`, token);
};

export const AddFavorite = async (profileId: number | string, params: unknown, token: string) => {
  return await POST(`/favorites?profile=${profileId}`, params, token);
};

export const RemoveFavorite = async (
  profileId: number | string,
  id: number | string,
  token: string,
) => {
  return await DELETE(`/favorites/${id}?profile=${profileId}`, token);
};
